import { render } from "./VideoCallPage.vue?vue&type=template&id=1b797097"
import script from "./VideoCallPage.vue?vue&type=script&lang=js"
export * from "./VideoCallPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__